"use client";
import { Card, Typography } from "antd";
import "./HelpSection.css";
import CardChevron from "@/Components/Common/CardChevron";
import Link from "next/link";
import { useIntl } from "react-intl";

type HelpCardItem = {
  id: string; // intl ID
  to: string; // URL path
};

const helpCardItems: HelpCardItem[] = [
  {
    id: "createServiceRequestClaimText",
    to: "/service-request-claim/sdl43601-5d24d-fds4-kf95-ls8g7hf5hd67", // "sdl43601-5d24d-fds4-kf95-ls8g7hf5hd67" is required a static, it's identification key.
  },
  {
    id: "contactUs",
    to: "/contact",
  },
  // {
  //   id: "feedbackAndSuggestions",
  //   to: "/contact",
  // },
];

const HelpCard = ({ id, to }: HelpCardItem) => {
  const intl = useIntl();

  return (
    <Link href={to} className="unset-link-style">
      <Card className="card-shadow mt-4 help-card clickable">
        <Typography className="fs-16 fw-500 lh-normal">
          {intl.formatMessage({ id })}
        </Typography>
        <CardChevron direction="right" width={9.5} height={5.5} />
      </Card>
    </Link>
  );
};

const HelpSection = () => {
  const intl = useIntl();

  return (
    <div className="help-container">
      <Typography.Title level={1} className="fw-700 fs-24">
        {intl.formatMessage({ id: "support" })}
      </Typography.Title>

      <div className="d-flex flex-col gap-12">
        {helpCardItems.map((item, index) => (
          <HelpCard key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

export default HelpSection;
